"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PluginsController", {
    enumerable: true,
    get: function() {
        return PluginsController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _pluginsservice = require("~/services/plugins.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let PluginsController = class PluginsController {
    async pluginList() {
        return new _PagedResponse.PagedResponseImpl(await this.pluginsService.pluginList());
    }
    async webhookPluginList() {
        return new _PagedResponse.PagedResponseImpl(await this.pluginsService.webhookPluginList());
    }
    async pluginTest(body, req) {
        return await this.pluginsService.pluginTest({
            body: body,
            req
        });
    }
    async pluginRead(pluginId) {
        return await this.pluginsService.pluginRead({
            pluginId: pluginId
        });
    }
    async pluginUpdate(body, pluginId, req) {
        const plugin = await this.pluginsService.pluginUpdate({
            pluginId: pluginId,
            plugin: body,
            req
        });
        return plugin;
    }
    async isPluginActive(pluginId) {
        return await this.pluginsService.isPluginActive({
            pluginId
        });
    }
    constructor(pluginsService){
        this.pluginsService = pluginsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/plugins',
        '/api/v2/meta/plugins'
    ]),
    (0, _extractidsmiddleware.Acl)('pluginList', {
        scope: 'org'
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], PluginsController.prototype, "pluginList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/plugins/webhook',
        '/api/v2/meta/plugins/webhook'
    ]),
    (0, _extractidsmiddleware.Acl)('webhookPluginList', {
        scope: 'org'
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], PluginsController.prototype, "webhookPluginList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/plugins/test',
        '/api/v2/meta/plugins/test'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('pluginTest', {
        scope: 'org'
    }),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], PluginsController.prototype, "pluginTest", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/plugins/:pluginId',
        '/api/v2/meta/plugins/:pluginId'
    ]),
    (0, _extractidsmiddleware.Acl)('pluginRead', {
        scope: 'org'
    }),
    _ts_param(0, (0, _common.Param)('pluginId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PluginsController.prototype, "pluginRead", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/plugins/:pluginId',
        '/api/v2/meta/plugins/:pluginId'
    ]),
    (0, _extractidsmiddleware.Acl)('pluginUpdate', {
        scope: 'org'
    }),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Param)('pluginId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], PluginsController.prototype, "pluginUpdate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/plugins/:pluginId/status',
        '/api/v2/meta/plugins/:pluginId/status'
    ]),
    (0, _extractidsmiddleware.Acl)('isPluginActive', {
        scope: 'org'
    }),
    _ts_param(0, (0, _common.Param)('pluginId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PluginsController.prototype, "isPluginActive", null);
PluginsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _pluginsservice.PluginsService === "undefined" ? Object : _pluginsservice.PluginsService
    ])
], PluginsController);
